import React from 'react'
import { Button, Grid} from "@mui/material";
import { usePreferences } from 'hooks/usePreferences';

export const ButtonType = {
    NEW_GLASSES: 'new_glasses',
    MANUAL_GLASSES: 'manual_glasses',
    MANUAL_LENS: 'manual_lens',
    MANUAL_CONTACT_LENS: 'manual_contact_lens',
    NEW_CONTACTS: 'new_contacts',
    FRAME: 'frame',
    LENS: 'lens',
    CONTACT_LENS: 'contact_lens',
    SERVICES: 'services',
    TREATMENTS: 'treatments',
    ACCESSORIES: 'accessories',
    SEND_TO_LAB: 'send_to_lab'
}

function InvoiceButtonComponent({ onButtonClick, disabled = false }) {

    const { preferences } = usePreferences();
    const manualEntryMode = preferences?.opticalEntryMode === 'manual';

    const handleButtonClick = (buttonType) => {
        onButtonClick(buttonType);
    }

  return (
    <Grid container spacing={1}>
    {!manualEntryMode && (
        <Grid item>
            <Button disabled={disabled} variant="outlined" onClick={() => handleButtonClick(ButtonType.NEW_GLASSES) }>New Glasses</Button>
        </Grid>
    )}
    {manualEntryMode && (
        <Grid item>
            <Button disabled={disabled} variant="outlined" onClick={() => handleButtonClick(ButtonType.MANUAL_GLASSES)}>Add Frame</Button>
        </Grid>
    )}
    {manualEntryMode && (
        <Grid item>
            <Button disabled={disabled} variant="outlined" onClick={() => handleButtonClick(ButtonType.MANUAL_LENS)}>Add Lens</Button>
        </Grid>
    )}
    {manualEntryMode && (
        <Grid item>
            <Button disabled={disabled} variant="outlined" onClick={() => handleButtonClick(ButtonType.MANUAL_CONTACT_LENS)}>Add Contact Lens</Button>
        </Grid>
    )}
    {!manualEntryMode && (
        <Grid item>
            <Button disabled={disabled} variant="outlined" onClick={() => handleButtonClick(ButtonType.CONTACT_LENS)}>Contact Lenses</Button>
        </Grid>
    )}
    {!manualEntryMode && (
        <Grid item>
            <Button disabled={disabled} variant="outlined" onClick={() => handleButtonClick(ButtonType.FRAME)}>Frame</Button>
        </Grid>
    )}
    {/* <Grid item>
        <Button variant="outlined" onClick={() => handleButtonClick(ButtonType.LENS)}>Lens</Button>
    </Grid> */}
    <Grid item>
        <Button disabled={disabled} variant="outlined" onClick={() => handleButtonClick(ButtonType.SERVICES)}>Services</Button>
    </Grid>
    {/* <Grid item>
        <Button variant="outlined" onClick={() => handleButtonClick(ButtonType.TREATMENTS)}>Treatments</Button>
    </Grid> */}
    <Grid item>
        <Button disabled={disabled} variant="outlined" onClick={() => handleButtonClick(ButtonType.ACCESSORIES)}>Accessories</Button>
    </Grid>
    {/* <Grid item>
        <Divider orientation='vertical' />
    </Grid> */}
    {/* <Grid item>
        <Button variant='contained' onClick={() => handleButtonClick(ButtonType.SEND_TO_LAB)}>Send to Lab</Button>
    </Grid>     */}
</Grid>
  )
}

export default InvoiceButtonComponent